/* OVRS — pack builder
   ==================================================================
   A regra que manda nesta tela:

   A Shopify NAO zera "a peca que o cliente marcou como brinde". Ela zera as N
   pecas ELEGIVEIS MAIS BARATAS do carrinho. Entao o total daqui e calculado do
   mesmo jeito: soma tudo, ordena os elegiveis por preco e desconta os N mais
   baratos. Qualquer outra conta faz a tela prometer um valor e o checkout
   cobrar outro — foi exatamente o P0 de agosto.

   O add continua atomico em /cart/add.js. O Section Store Cart e o carrinho
   principal; a gaveta do Ecomus fica apenas como fallback. */
(function () {
  var raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function dinheiro(centavos) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(centavos);
    return '$' + (centavos / 100).toFixed(2);
  }

  function iniciar(secao) {
    if (secao.dataset.ovrsPbReady === '1') return;
    var fonte = secao.parentNode.querySelector('[data-ovrs-pb="' + secao.id.replace('ovrs-pb-', '') + '"]')
      || document.querySelector('[data-ovrs-pb]');
    if (!fonte) return;

    var dados;
    try { dados = JSON.parse(fonte.textContent); } catch (e) { console.error('[ovrs-pb] dados invalidos', e); return; }
    if (!dados.lanes || !dados.lanes.length || !dados.tiers || !dados.tiers.length) return;
    secao.dataset.ovrsPbReady = '1';

    var txt = dados.strings || {};
    var elTiers = secao.querySelector('[data-tiers]');
    var elLanes = secao.querySelector('[data-lanes]');
    var elSlots = secao.querySelector('[data-slots]');
    var elExplica = secao.querySelector('[data-explica]');
    var elCount = secao.querySelector('[data-count-label]');
    var elSub = secao.querySelector('[data-subtotal]');
    var elSaveLine = secao.querySelector('[data-save-line]');
    var elSaveLabel = secao.querySelector('[data-save-label]');
    var elSave = secao.querySelector('[data-save]');
    var elTotal = secao.querySelector('[data-total]');
    var elMsg = secao.querySelector('[data-msg]');
    var btnAdd = secao.querySelector('[data-add]');

    var picker = secao.querySelector('[data-picker]');
    var pickerTitulo = secao.querySelector('[data-picker-title]');
    var pickerLista = secao.querySelector('[data-picker-list]');

    var tierAtivo = 0;
    var laneAtiva = 0;
    var slots = [];
    var botoesLane = [];
    var botoesTier = [];
    var slotAberto = null;
    var focoAnterior = null;
    var adicionando = false;
    dados.tiers.forEach(function (t, i) { if (t.preselected) tierAtivo = i; });

    function aviso(t, erro) {
      elMsg.textContent = t || '';
      elMsg.classList.toggle('is-err', !!erro);
    }

    /* ---------------- montagem dos slots ---------------- */

    // handle da colecao -> rotulo que o lojista deu para a trilha. Sem isso a
    // vaga travada diria "Piece" em vez de "Hoodies", e o cliente nao saberia
    // o que aquela posicao aceita.
    var rotuloDoPool = {};
    (dados.lanes || []).forEach(function (l) {
      if (l.handle) rotuloDoPool[l.handle] = l.title;
    });

    /* A colecao do brinde: da trilha quando ela tem regra propria, senao do
       tier. E o mesmo handle que o desconto da loja usa do lado "ganha" —
       trocar aqui muda a conta, o seletor e a lista de elegiveis de uma vez,
       porque os tres leem daqui. */
    function poolBrinde() {
      var t = dados.tiers[tierAtivo];
      var l = dados.lanes[laneAtiva];
      // Receita travada manda em tudo, brinde incluso: a barra de trilhas nem
      // aparece ali, entao deixar a trilha decidir o brinde seria obedecer a
      // uma escolha que o cliente nao ve.
      if ((t.recipe || []).length > 0) return t.freeCollection || null;
      // Trilha que nao cabe no tier tambem nao manda no brinde. Isso deixa a
      // ordem das chamadas irrelevante: a conta nunca depende de `pintarLanes`
      // ja ter corrigido `laneAtiva`.
      if (l && l.freeCollection && tierCabeNaLane(t, l)) return l.freeCollection;
      return t.freeCollection || null;
    }

    /* Quem manda e a TRILHA: escolhida a categoria, so ficam de pe os niveis
       que a loja realmente sabe cobrar para ela. Moletom tem regra de 2 pagos
       e nao tem de 3 — entao o 3+2 some quando o moletom esta ativo.

       Nivel com receita travada (Full fit) passa sempre: ali a trilha nao
       escolhe nada, cada vaga ja carrega a categoria dela.
       `maxPaid` = 0 quer dizer "sem teto, aparece em todos". */
    function tierCabeNaLane(t, l) {
      if (!t) return false;
      if ((t.recipe || []).length > 0) return true;
      return !(l && l.maxPaid > 0 && t.paid > l.maxPaid);
    }

    function montarSlots() {
      // primeiro resolve QUAL nivel vale para a trilha ativa: montar as vagas
      // antes disso montaria o pack errado e so depois trocaria o botao.
      pintarTiers();
      var t = dados.tiers[tierAtivo];
      var receita = t.recipe || [];
      slots = [];

      for (var i = 0; i < t.paid; i++) {
        // Receita curta demais nao inventa categoria: as vagas que sobram
        // voltam a ser livres em vez de repetir a ultima em silencio.
        var pool = receita[i] || null;
        slots.push({
          tipo: 'paid',
          pool: pool,
          rotulo: pool ? (rotuloDoPool[pool] || pool) : null,
          escolha: null
        });
      }

      var poolFree = poolBrinde();
      for (var j = 0; j < t.free; j++) {
        slots.push({
          tipo: 'free',
          pool: poolFree,
          rotulo: null,
          escolha: null
        });
      }

      pintarExplicacao();
      pintarLanes();
      pintarSlots();
      pintarResumo();
    }

    // A frase que explica o pack. Sem ela o cliente ve cinco quadrados e nao
    // sabe que a oferta e "moletom + short + logo tee, e duas lisas de graca".
    function pintarExplicacao() {
      if (!elExplica) return;
      var t = dados.tiers[tierAtivo];
      var texto = (t.explain || '').trim();
      elExplica.textContent = texto;
      elExplica.hidden = !texto;
    }

    // Trilhas so fazem sentido quando o cliente escolhe a categoria. Com
    // receita travada, quem manda e a vaga — mostrar as abas ali seria
    // oferecer uma escolha que a proxima tela vai ignorar.
    function pintarLanes() {
      if (!elLanes) return;
      var t = dados.tiers[tierAtivo];
      var travado = (t.recipe || []).length > 0;
      elLanes.hidden = travado;
      if (!travado) {
        botoesLane.forEach(function (b, i) {
          b.setAttribute('aria-selected', i === laneAtiva ? 'true' : 'false');
        });
      }
    }

    /* Esconde os niveis que nao valem para a categoria escolhida e, se o nivel
       ativo foi um dos que sumiram, cai no primeiro que sobrou. Sem essa queda
       a tela ficaria montando um pack de um nivel que o cliente nao ve mais —
       e cobrando por ele. */
    function pintarTiers() {
      if (!botoesTier.length) return;
      var l = dados.lanes[laneAtiva];

      if (!tierCabeNaLane(dados.tiers[tierAtivo], l)) {
        for (var i = 0; i < dados.tiers.length; i++) {
          if (tierCabeNaLane(dados.tiers[i], l)) { tierAtivo = i; break; }
        }
      }

      botoesTier.forEach(function (b, i) {
        b.hidden = !tierCabeNaLane(dados.tiers[i], l);
        b.setAttribute('aria-selected', i === tierAtivo ? 'true' : 'false');
      });
    }

    function pintarSlots() {
      elSlots.innerHTML = '';
      slots.forEach(function (slot, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ovrs-pb__slot' + (slot.tipo === 'free' ? ' ovrs-pb__slot--free' : '') + (slot.escolha ? ' is-filled' : '');
        b.setAttribute('data-slot', String(i));
        b.disabled = adicionando;

        // Vaga travada mostra a CATEGORIA que ela aceita; vaga livre mostra
        // o rotulo generico. E a diferenca entre 'Piece' e 'Hoodies'.
        var rotulo = slot.rotulo || (slot.tipo === 'free' ? txt.freeSlot : txt.paidSlot);
        var media = '<div class="ovrs-pb__slot-media">'
          + '<span class="ovrs-pb__slot-tag">' + escapar(rotulo) + '</span>'
          + (slot.escolha && slot.escolha.image
              ? '<img src="' + slot.escolha.image + '" alt="" loading="lazy">'
              : '<span class="ovrs-pb__slot-ph">' + escapar(txt.empty || '') + '</span>')
          + '</div>';

        var info = '<span class="ovrs-pb__slot-info">'
          + '<span class="ovrs-pb__slot-name">' + escapar(slot.escolha ? slot.escolha.title : rotulo) + '</span>'
          + '<span class="ovrs-pb__slot-size">'
          + escapar(slot.escolha ? slot.escolha.size + ' · ' + dinheiro(slot.escolha.price) : (txt.choose || ''))
          + '</span></span>';

        b.innerHTML = media + info;
        b.addEventListener('click', function () { abrirPicker(i); });
        elSlots.appendChild(b);
      });
    }

    /* ---------------- a conta ---------------- */

    /* Elegivel = esta na colecao de brinde do tier. E a mesma lista que o
       desconto da loja usa; por isso o pool vem do editor, nao do tipo do
       produto. */
    function idsElegiveis() {
      var pool = dados.pools[poolBrinde()] || [];
      var ids = {};
      pool.forEach(function (p) { p.variants.forEach(function (v) { ids[v.id] = true; }); });
      return ids;
    }

    function calcular() {
      var t = dados.tiers[tierAtivo];
      var escolhidos = slots.map(function (s) { return s.escolha; }).filter(Boolean);
      var subtotal = escolhidos.reduce(function (a, e) { return a + e.price; }, 0);

      var elegiveis = idsElegiveis();
      var precosElegiveis = escolhidos
        .filter(function (e) { return elegiveis[e.variantId]; })
        .map(function (e) { return e.price; })
        .sort(function (a, b) { return a - b; });

      // so desconta se o pack estiver completo: desconto parcial nao existe
      var completo = escolhidos.length === slots.length;
      var desconto = 0;
      if (completo) {
        for (var i = 0; i < t.free && i < precosElegiveis.length; i++) desconto += precosElegiveis[i];
      }

      return { subtotal: subtotal, desconto: desconto, total: subtotal - desconto, itens: escolhidos.length, completo: completo };
    }

    function pintarResumo() {
      var c = calcular();
      elCount.textContent = (txt.count || '[n]').replace('[n]', String(c.itens));
      elSub.textContent = dinheiro(c.subtotal);

      if (c.desconto > 0) {
        elSaveLine.hidden = false;
        elSaveLabel.textContent = txt.save || '';
        /* sem '-': o rotulo ao lado ja diz "You save". Junto virava
         "You save -$79.68", que le como economia negativa. */
        elSave.textContent = dinheiro(c.desconto);
      } else {
        elSaveLine.hidden = true;
      }

      elTotal.textContent = dinheiro(c.total);
      btnAdd.textContent = txt.add || 'Add';
      btnAdd.disabled = adicionando;
    }

    /* ---------------- janela de escolha ---------------- */

    function produtosPara(slot) {
      var t = dados.tiers[tierAtivo];
      // Vaga com pool proprio manda: e o que trava a categoria da posicao.
      // Sem pool, cai na trilha que o cliente escolheu, como antes.
      if (slot.pool) return dados.pools[slot.pool] || [];
      if (slot.tipo === 'free') return dados.pools[poolBrinde()] || [];
      return (dados.lanes[laneAtiva] && dados.lanes[laneAtiva].products) || [];
    }

    function abrirPicker(indice) {
      slotAberto = indice;
      focoAnterior = document.activeElement;
      var slot = slots[indice];
      pickerTitulo.textContent = (slot.tipo === 'free' ? txt.freeSlot : txt.paidSlot) + ' — ' + (txt.choose || '');

      pickerLista.innerHTML = '';
      produtosPara(slot).forEach(function (p) {
        var disponiveis = p.variants.filter(function (v) { return v.available; });
        var card = document.createElement('div');
        card.className = 'ovrs-pb__card';

        var precoBase = disponiveis.length ? disponiveis[0].price : (p.variants[0] || {}).price;
        card.innerHTML = '<div class="ovrs-pb__card-media">'
          + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '')
          + '</div>'
          + '<div class="ovrs-pb__card-body">'
          + '<span class="ovrs-pb__card-name">' + escapar(p.title) + '</span>'
          + '<span class="ovrs-pb__card-price">' + (precoBase != null ? dinheiro(precoBase) : escapar(txt.soldOut || '')) + '</span>'
          + '<div class="ovrs-pb__sizes"></div>'
          + '</div>';

        var caixaTam = card.querySelector('.ovrs-pb__sizes');
        p.variants.forEach(function (v) {
          var s = document.createElement('button');
          s.type = 'button';
          s.className = 'ovrs-pb__size';
          s.textContent = v.size || v.title;
          if (!v.available) { s.disabled = true; }
          s.addEventListener('click', function () {
            var indiceEscolhido = slotAberto;
            slots[indiceEscolhido].escolha = {
              variantId: v.id,
              title: p.title,
              size: v.size || v.title,
              price: v.price,
              image: p.image
            };
            pintarSlots();
            pintarResumo();
            fecharPicker(elSlots.querySelector('[data-slot="' + indiceEscolhido + '"]'));
            aviso('');
          });
          caixaTam.appendChild(s);
        });

        pickerLista.appendChild(card);
      });

      picker.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var fechar = picker.querySelector('.ovrs-pb__picker-x');
      if (fechar) fechar.focus();
    }

    function fecharPicker(alvoFoco) {
      picker.hidden = true;
      document.documentElement.style.overflow = '';
      var alvo = alvoFoco && typeof alvoFoco.focus === 'function' ? alvoFoco : focoAnterior;
      if (alvo && alvo.focus) alvo.focus();
    }

    secao.querySelectorAll('[data-picker-close]').forEach(function (b) {
      b.addEventListener('click', fecharPicker);
    });

    picker.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); fecharPicker(); return; }
      if (e.key !== 'Tab') return;
      var focaveis = Array.prototype.slice.call(
        picker.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return !el.hidden && el.getClientRects().length; });
      if (!focaveis.length) return;
      var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
      if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
    });

    /* ---------------- adicionar ---------------- */

    function contarPacks(cart) {
      var grupos = {};
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {}, id = props._ovrs_pack;
        if (!id) return;
        if (!grupos[id]) grupos[id] = { quantidade: 0, tamanho: Number(props._ovrs_pack_size) || 1 };
        grupos[id].quantidade += Number(item.quantity) || 0;
      });
      return Object.keys(grupos).filter(function (id) {
        return grupos[id].quantidade >= grupos[id].tamanho;
      }).length;
    }

    function idDoPack() {
      return window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }

    function travarCompra(on) {
      adicionando = on;
      secao.setAttribute('aria-busy', String(on));
      botoesTier.concat(botoesLane).forEach(function (b) { b.disabled = on; });
      elSlots.querySelectorAll('button').forEach(function (b) { b.disabled = on; });
      btnAdd.disabled = on;
    }

    btnAdd.addEventListener('click', function () {
      if (adicionando) return;
      var c = calcular();
      if (!c.completo) {
        aviso(txt.incomplete || '', true);
        var vazio = elSlots.querySelector('.ovrs-pb__slot:not(.is-filled)');
        if (vazio) vazio.focus();
        return;
      }

      var tamanho = slots.length;
      var itensSelecionados = slots.map(function (s) {
        return { id: s.escolha.variantId, quantity: 1 };
      });
      travarCompra(true);
      aviso('');

      fetch(raiz + '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Cart unavailable');
            return data;
          });
        })
        .then(function (cart) {
          if (contarPacks(cart) >= (dados.maxPacks || 1)) {
            var limite = new Error(txt.maxReached || 'Pack limit reached.');
            limite.ovrsMax = true;
            throw limite;
          }
          var packId = idDoPack();
          var itens = itensSelecionados.map(function (item) {
            return { id: item.id, quantity: 1, properties: { _ovrs_pack: packId, _ovrs_pack_size: String(tamanho) } };
          });
          return fetch(raiz + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: itens })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
            return data;
          });
        })
        .then(function () {
          abrirCarrinho();
          montarSlots();
        })
        .catch(function (err) {
          if (!err.ovrsMax) console.error('[ovrs-pb]', err);
          aviso(err.message, true);
        })
        .finally(function () { travarCompra(false); pintarResumo(); });
    });

    /* ---------------- abas ---------------- */

    // Mesmo padrao da caixa de compra da PDP: UM selo vermelho, o resto preto.
    // Vermelho e a cor de empurrar uma opcao — dois vermelhos na mesma tela
    // nao empurram nada, so competem entre si. O vermelho vai para o tier
    // pre-selecionado (o que a loja recomenda); sem nenhum marcado, vai para
    // o primeiro, que e o que aparece aberto de qualquer jeito.
    var tierDestaque = dados.tiers.findIndex(function (t) { return t.preselected; });
    if (tierDestaque < 0) tierDestaque = 0;

    /* Os botoes de nivel e de trilha agora nascem PRONTOS no Liquid.

       Antes esta funcao criava os dois grupos do zero. Como o Liquid ja tem os
       blocos de `tier` e de `lane`, isso significava deixar dois containers com
       altura zero no HTML e enche-los depois — 244px de niveis e 44px de
       trilhas aparecendo de uma vez e empurrando a pagina inteira para baixo.
       Era a maior parte do CLS de 0,375 medido em 06/09/2026.

       O JS passa a ADOTAR o que ja esta na tela: pega os botoes, liga os
       eventos e segue igual. A construcao antiga fica como plano B para o caso
       de a marcacao e os dados desencontrarem (bloco novo no editor, cache de
       section antigo). Sem esse plano B, um desencontro deixaria a pagina sem
       botao nenhum, que e falha pior do que a que estamos consertando. */
    function adotarOuCriar(container, lista, montar) {
      if (!container) return [];
      var existentes = container.children;
      if (existentes.length === lista.length) {
        return Array.prototype.slice.call(existentes);
      }
      container.innerHTML = '';
      return lista.map(function (item, i) {
        var b = montar(item, i);
        container.appendChild(b);
        return b;
      });
    }

    botoesTier = adotarOuCriar(elTiers, dados.tiers, function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ovrs-pb__tier';
      b.setAttribute('aria-selected', i === tierAtivo ? 'true' : 'false');
      var classeSelo = 'ovrs-pb__tier-badge' + (i === tierDestaque ? '' : ' is-black');
      b.innerHTML = '<span class="ovrs-pb__tier-name">' + escapar(t.title) + '</span>'
        + '<span class="ovrs-pb__tier-sub">' + escapar(t.subtitle || '') + '</span>'
        + (t.badge ? '<span class="' + classeSelo + '">' + escapar(t.badge) + '</span>' : '');
      return b;
    });

    botoesTier.forEach(function (b, i) {
      b.addEventListener('click', function () {
        tierAtivo = i;
        montarSlots();
        aviso('');
      });
    });

    if (elLanes) {
      botoesLane = adotarOuCriar(elLanes, dados.lanes, function (l, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ovrs-pb__lane';
        b.textContent = l.title;
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        return b;
      });

      botoesLane.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var poolAnterior = poolBrinde();
          laneAtiva = i;
          elLanes.querySelectorAll('.ovrs-pb__lane').forEach(function (x, n) {
            x.setAttribute('aria-selected', n === i ? 'true' : 'false');
          });
          // pode derrubar o nivel ativo; guarda para saber se mudou
          var tierAnterior = tierAtivo;
          pintarTiers();
          // Trocar de categoria limpa so os slots pagos — o brinde vem de
          // outra colecao e continua valendo. Duas excecoes refazem o quadro
          // inteiro: a trilha com regra propria (Conjunto), onde o brinde MUDA
          // de colecao e a peca escolhida antes nao pertence mais ao pack; e a
          // trilha que derruba o nivel ativo (moletom nao tem 3+2).
          if (poolBrinde() !== poolAnterior || tierAtivo !== tierAnterior) {
            montarSlots();
          } else {
            slots.forEach(function (s) { if (s.tipo === 'paid') s.escolha = null; });
            pintarSlots();
            pintarResumo();
          }
        });
      });
    }

    /* Arrastar as faixas horizontais.

       No dedo o `overflow-x: auto` ja arrasta sozinho. Isto aqui e para o
       PONTEIRO: com mouse — e no modo responsivo do DevTools, que e onde a
       loja e testada — arrastar nao rola nada, e como a barra de rolagem esta
       escondida o carrossel parece travado.

       O cuidado que nao pode faltar: as vagas sao BOTOES que abrem o seletor.
       Sem bloquear o clique depois de um arrasto, tentar rolar abriria a
       janela de escolha na cara do cliente. */
    function ligarArrasto(faixa) {
      if (!faixa || faixa.dataset.arrastoOk === '1') return;
      faixa.dataset.arrastoOk = '1';

      var arrastando = false, x0 = 0, s0 = 0, andou = 0;

      /* NAO usar setPointerCapture aqui.

         A captura de ponteiro nao redireciona so pointermove: a especificacao
         manda o `click` tambem ir para o elemento que capturou. Como quem
         capturava era a FAIXA, o clique do mouse chegava em .ovrs-pb__slots e
         nunca no <button> da vaga — o seletor nao abria no desktop, e so no
         desktop, porque no dedo o handler sai antes (pointerType 'touch').

         Medido na loja no ar, 1024px, clique real no centro da primeira vaga:
         target = .ovrs-pb__slots, o botao nao recebeu nada.

         Ouvir move/up na janela da o mesmo que a captura dava — o arrasto
         continua valendo se o cursor sair da faixa — sem mexer no alvo do
         clique. */
      function mover(e) {
        if (!arrastando) return;
        var d = e.clientX - x0;
        andou = Math.max(andou, Math.abs(d));
        faixa.scrollLeft = s0 - d;
      }

      function soltar() {
        if (!arrastando) return;
        arrastando = false;
        faixa.classList.remove('is-arrastando');
        window.removeEventListener('pointermove', mover);
        window.removeEventListener('pointerup', soltar);
        window.removeEventListener('pointercancel', soltar);
      }

      faixa.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // dedo ja e nativo
        // Nada para rolar, nada para arrastar. No desktop a faixa vira grade
        // sem transbordo, e sair capturando ali era so criar problema.
        if (faixa.scrollWidth <= faixa.clientWidth) return;
        arrastando = true;
        andou = 0;
        x0 = e.clientX;
        s0 = faixa.scrollLeft;
        faixa.classList.add('is-arrastando');
        window.addEventListener('pointermove', mover);
        window.addEventListener('pointerup', soltar);
        window.addEventListener('pointercancel', soltar);
      });

      /* As vagas sao BOTOES que abrem o seletor. Sem isto, terminar um arrasto
         em cima de uma vaga abriria a janela de escolha na cara do cliente. */
      faixa.addEventListener('click', function (e) {
        if (andou > 6) { e.preventDefault(); e.stopPropagation(); andou = 0; }
      }, true);
    }

    ligarArrasto(elSlots);
    ligarArrasto(elLanes);

    montarSlots();
  }

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function abrirCarrinhoNativo() {
    document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
    var trigger = document.querySelector('a[aria-controls="CartDrawer"]');
    if (!trigger) { window.location.href = raiz + '/cart'; return; }
    var done = false, timer;
    var onRender = function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      document.removeEventListener('cart:drawer:render', onRender);
      trigger.click();
    };
    timer = setTimeout(function () {
      if (done) return;
      done = true;
      document.removeEventListener('cart:drawer:render', onRender);
      window.location.href = raiz + '/cart';
    }, 2500);
    document.addEventListener('cart:drawer:render', onRender);
  }

  function irParaCarrinho() {
    window.location.href = raiz + '/cart';
  }

  function abrirCarrinho() {
    var app = window.SectionStoreCart;
    if (app && typeof app.open === 'function') {
      try {
        var abertura = app.open();
        if (abertura && typeof abertura.catch === 'function') abertura.catch(irParaCarrinho);
        return;
      } catch (err) { irParaCarrinho(); return; }
    }
    abrirCarrinhoNativo();
  }

  function iniciarTodas() {
    /* A classe faz parte do seletor de proposito. O prefixo `ovrs-pb-` sozinho
       tambem casa com o <h2 id="ovrs-pb-picker-title-..."> que fica DENTRO da
       section: `iniciar` rodava nele, todos os `querySelector` davam null e a
       linha `picker.addEventListener('keydown', ...)` estourava
       `TypeError: Cannot read properties of null` a cada carregamento.
       A section ja tinha inicializado antes (vem primeiro na ordem do
       documento), entao a tela funcionava e o erro so aparecia no console —
       mas voltava a cada `shopify:section:load` no editor de temas. */
    document.querySelectorAll('.ovrs-pb[id^="ovrs-pb-"]').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodas);
  else iniciarTodas();

  document.addEventListener('shopify:section:load', iniciarTodas);
})();
